import { default as MuiTableContainer } from '@mui/material/TableContainer';

/**
 * TableContainer wraps a Table with scroll and overflow handling.
 *
 * Demos:
 *
 * - [Table](https://unify.workiva.org/components/table?tab=code)
 *
 * API:
 *
 * - [TableContainer API](https://unify.workiva.org/components/table?tab=props#tablecontainer)
 */
export const TableContainer = MuiTableContainer;
export {
  type TableContainerProps,
  tableContainerClasses,
} from '@mui/material/TableContainer';
